import styled from 'styled-components'
import ButtonText from 'components/button/ButtonText'

const WebAuthnSetupAcceptButtonContainer = styled.div`
  ${ButtonText} {
    position: absolute;
  }
`

export default WebAuthnSetupAcceptButtonContainer
